import electron from './electron'
import settings from './settings.yaml'
import stage from './stage.yaml'

export default {
  stage,
  settings,
  electron,
}
